import { AppletHost } from '@meltwater/applet-host';
import languageTranslations from './language-translations';
import { reportRegistrarKey, ViewMode } from '@meltwater/report-sdk';
import { Translations } from '@meltwater/vanilla-translations';
import { UserClient } from '@meltwater/gaf-identity-client';

export * from './translation-keys';

const initPromise = Translations.create(languageTranslations);

export const getTranslations = async () => {
    const appletHost = await AppletHost.getInstance();
    const reportRegistrar = appletHost.getRegistrar(reportRegistrarKey);

    let language = 'en';
    if (reportRegistrar && reportRegistrar.viewMode === ViewMode.HTML) {
        const userLocale = reportRegistrar.getLocale();
        if (userLocale !== null) {
            language = userLocale;
        }
    } else {
        const userClient = await UserClient.getInstance();
        const user = await userClient.getCurrentUser();
        language = user.language;
    }
    const translations = await initPromise;
    await translations.setLanguage(language);

    return translations;
};
